import { SnackbarProvider } from 'notistack';
import React, { useEffect } from 'react';
// import ReactGA from 'react-ga';
import { Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import SearchPage from './pages/SearchPage/SearchPage';
import NavBar from './components/NavBar/NavBar';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import GlobalContext from './Context/GlobalContext/GlobalContextProvider';
import UserContext from './Context/UserContext/UserContextProvider';
import LoggingContextProvider from './Context/LoggingContext/LoggingContext';
import { IdealMeasuresGenerator } from './components/IdealMeasuresGenerator/IdealMeasuresGenerator';
import InputIdealTeeMeasurements from './pages/IdealTeeMeasures/InputIdealTeeMeasurements';
import GarmentPage from './pages/GarmentPage/GarmentPage';

// Google Analytics set up
const googleAnalyticsTrackingCode = process.env.REACT_APP_GA_TRACKING_CODE_MEASUREMENT_ID;
if (typeof googleAnalyticsTrackingCode === 'string') {
  ReactGA.initialize([
    {
      trackingId: googleAnalyticsTrackingCode,
    },
  ]);
} else throw new Error('THERE IS NO ENV VARIABLE FOR GOOGLE ANALYTICS');

function App() {
  const location = useLocation();

  // Google Analytics to send data on each page change
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [location.pathname]);

  return (
    <SnackbarProvider maxSnack={5}>
      <LoggingContextProvider>
        <GlobalContext>
          <UserContext>
            <IdealMeasuresGenerator />
            <NavBar />
            <Routes>
              <Route path='/' element={<SearchPage />} />
              <Route path='/settings' element={<SettingsPage />} />
              <Route path='/idealmeasurements' element={<InputIdealTeeMeasurements />} />
              <Route path='/garmentpage/:garment/:garmenttypeid/:size/*' element={<GarmentPage />} />
            </Routes>
          </UserContext>
        </GlobalContext>
      </LoggingContextProvider>
    </SnackbarProvider>
  );
}

export default App;
